import { render, staticRenderFns } from "./Detial.vue?vue&type=template&id=29f4138b"
import script from "./Detial.vue?vue&type=script&lang=js"
export * from "./Detial.vue?vue&type=script&lang=js"
import style0 from "./Detial.vue?vue&type=style&index=0&id=29f4138b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports